import React from 'react';
import { X, AlertCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const QuitMeetingPopup = ({ isOpen, onClose, onConfirm, meetingTitle }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleConfirm = () => {
    // Fermer le popup
    if (onConfirm) {
      onConfirm();
    }
    // Rediriger vers la page Mes Réunions
    navigate('/mes-reunions');
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <button onClick={onClose} style={styles.closeButton}>
          <X size={20} />
        </button>

        <div style={styles.iconContainer}>
          <AlertCircle size={48} color="#ef4444" />
        </div>

        <h2 style={styles.title}>Quitter la réunion ?</h2>

        <p style={styles.message}>
          Êtes-vous sûr de vouloir quitter la réunion <strong>"{meetingTitle}"</strong> ?
        </p>

        <p style={styles.warning}>
          Vous pourrez toujours y accéder plus tard depuis la liste des réunions.
        </p>

        <div style={styles.buttons}>
          <button onClick={onClose} style={styles.cancelButton}>
            Annuler
          </button>
          <button onClick={handleConfirm} style={styles.confirmButton}>
            Quitter
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000,
    backdropFilter: 'blur(4px)',
  },
  modal: {
    background: 'white',
    borderRadius: 20,
    padding: '30px',
    width: '90%',
    maxWidth: 400,
    position: 'relative',
    textAlign: 'center',
    boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
  },
  closeButton: {
    position: 'absolute',
    top: 15,
    right: 15,
    background: '#f3f4f6',
    border: 'none',
    borderRadius: 8,
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: '#666',
    transition: 'all 0.2s',
    ':hover': {
      background: '#e5e7eb',
    },
  },
  iconContainer: {
    marginBottom: 20,
  },
  title: {
    fontSize: 22,
    fontWeight: 600,
    color: '#1f1f2e',
    marginBottom: 12,
  },
  message: {
    fontSize: 15,
    color: '#4b5563',
    marginBottom: 8,
    lineHeight: 1.5,
  },
  warning: {
    fontSize: 13,
    color: '#6b7280',
    marginBottom: 24,
  },
  buttons: {
    display: 'flex',
    gap: 12,
    justifyContent: 'center',
  },
  cancelButton: {
    padding: '10px 24px',
    background: '#f3f4f6',
    border: '1px solid #e5e7eb',
    borderRadius: 30,
    fontSize: 14,
    fontWeight: 500,
    color: '#4b5563',
    cursor: 'pointer',
    transition: 'all 0.2s',
    ':hover': {
      background: '#e5e7eb',
    },
  },
  confirmButton: {
    padding: '10px 24px',
    background: '#ef4444',
    border: 'none',
    borderRadius: 30,
    fontSize: 14,
    fontWeight: 500,
    color: 'white',
    cursor: 'pointer',
    transition: 'all 0.2s',
    ':hover': {
      background: '#dc2626',
    },
  },
};

export default QuitMeetingPopup;